import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createClientAction } from '../../../redux/actions/clientsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import ClientForm from '../forms/ClientForm';

const CreateClientModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(createClientAction(data));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Додати деталь'}
      loading={loading}
      onClose={onModalClose}
      body={<ClientForm readOnly={false} onSubmit={onSubmit} loading={loading} />}
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'client-form'} children={'Зберегти'} />
      }
    />
  );
};

export default CreateClientModal;
